import { render, staticRenderFns } from "./UserSubject.vue?vue&type=template&id=80188b5a&scoped=true&"
import script from "./UserSubject.ts?vue&type=script&lang=ts&"
export * from "./UserSubject.ts?vue&type=script&lang=ts&"
import style0 from "./user-subject.scss?vue&type=style&index=0&id=80188b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80188b5a",
  null
  
)

export default component.exports